import { render, staticRenderFns } from "./professional-details.vue?vue&type=template&id=bf513ed0&scoped=true&"
import script from "./professional-details.vue?vue&type=script&lang=js&"
export * from "./professional-details.vue?vue&type=script&lang=js&"
import style0 from "./professional-details.vue?vue&type=style&index=0&id=bf513ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf513ed0",
  null
  
)

/* custom blocks */
import block0 from "./professional-details.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports